import { Divider, Stack } from '@mui/material';
import { useDictionary, useIsDesktop } from 'Hooks';
import { TextInformation } from '../DisabilityApprovalItem/TextInformation';
import { DownloadAndInfoButtons } from '../DisabilityApprovalItem/Download&InfoButtons';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

export const MedIssueReport = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.DisabilityApprovals
  ).medIssueReport;
  return (
    <Stack
      direction={isDesktop ? 'row' : 'column'}
      alignItems='center'
      bgcolor='white'
      padding={isDesktop ? '24px' : '16px 0 0 0'}
      borderRadius='16px'
      border='1px solid #E7EDFF'
      boxShadow={
        isDesktop ? undefined : '-2px -2px 10px 0px rgba(8, 30, 84, 0.04);'
      }
      gap={isDesktop ? '56px' : '24px'}
    >
      <TextInformation
        title={dictionary.title}
        description={dictionary.description}
      />
      {isDesktop && (
        <Divider
          orientation='vertical'
          sx={{ height: '72px', borderColor: 'primary.shade_200' }}
        />
      )}
      <DownloadAndInfoButtons
        title={dictionary.shortTitle}
        moreInfoLink='https://shikum.mod.gov.il/medical/Medicine/cannabis-license'
      />
    </Stack>
  );
};
